<div class="measure-details-panel">
  <div class="details-content">
    <div class="measure-info-container">
      <div class="measure-identity">
        <div class="info-row">
          <span class="label unselectable">Measure ID:</span>
          <span class="value unselectable">
            <ng-container *ngIf="measure.url; else plainText">
              <a
                [href]="measure.url"
                target="_blank"
                rel="noopener noreferrer"
                >{{ measure.name }}</a
              >
            </ng-container>
            <ng-template #plainText>{{ measure.name }}</ng-template>
          </span>
        </div>

        <div class="info-row">
          <span class="label unselectable">Measure:</span>
          <span class="value unselectable">{{
            measure.measureDescription
          }}</span>
        </div>
        <br />
        <div>
          <ng-container *ngIf="measure.highPriority"
            ><mat-chip>High Priority</mat-chip></ng-container
          >
          <ng-container *ngIf="measure.outcome"
            ><mat-chip class="subChip">Outcome</mat-chip></ng-container
          >
          <ng-container *ngIf="measure.noBenchmark"
            ><mat-chip class="subChip">No Benchmark</mat-chip></ng-container
          >
          <ng-container *ngIf="measure.inverse"
            ><mat-chip class="subChip">Inverse</mat-chip></ng-container
          >

          <div *ngIf="(measure.floor ?? 0) > 0 && (measure.isMIPS || measure.isMVP) && isDesignated">
            <br /><br />{{ getFloorText(measure.floor || 0) }}
          </div>
          <div *ngIf="measure.sevenPointCap && (measure.isMIPS || measure.isMVP) && isDesignated">
            <br /><br />Subject to 7-point scoring cap.
          </div>
        </div>
      </div>

      <div class="performance-container">
        <ngx-gauge
          [value]="getFormatedValue(measure.performance ?? 0)"
          [label]="'Performance %'"
          [append]="''"
          [thick]="15"
          [type]="'full'"
          [margin]="20"
          [foregroundColor]="'#03a9f4'"
        >
        </ngx-gauge>
      </div>

      <div class="points-display" *ngIf="measure.isMIPS || measure.isMVP">
        <div class="points-value">
          <div class="value unselectable">{{ points }}</div>
          <div class="label unselectable">Points</div>
        </div>
      </div>
    </div>

    <div class="data-quality-section">
      <h3>Data Completeness Requirements</h3>

      <div class="quality-metrics">
        <div class="quality-metric">
          <div class="metric-header">
            <span class="metric-label">Case Minimum (20 required)</span>
            <span
              class="metric-status"
              [class.met]="measure.effectiveCaseMinimumMet"
              [class.not-met]="!measure.effectiveCaseMinimumMet"
            >
              {{ measure.effectiveCaseMinimumMet ? "Met" : "Not Met" }}
            </span>
          </div>
        </div>

        <div class="quality-metric" *ngIf="measure.completeness !== undefined">
          <div class="metric-header">
            <span class="metric-label">Data Completeness (75% required)</span>
            <span
              class="metric-status"
              [class.met]="isCompletenessMet(measure)"
              [class.not-met]="!isCompletenessMet(measure)"
            >
              {{ isCompletenessMet(measure) ? "Met" : "Not Met" }}
            </span>
          </div>
        </div>
      </div>

      <div
        class="alert-box"
        *ngIf="!measure.effectiveCaseMinimumMet || (measure.completeness !== undefined && !isCompletenessMet(measure))"
      >
        <mat-icon>info</mat-icon>
        <p>
          <strong>This measure does not meet CMS reporting requirements.</strong>
          Performance will be scored as 0% for MIPS calculations.
          {{ getDataQualityMessage(measure) }}
        </p>
      </div>
    </div>

    <div class="goal-section" *ngIf="isDesignated; else noAdjustableGoal">
      <div class="goal-header">
        <div class="legend">
          <div class="legend-item">
            <div class="legend-marker last-year"></div>
            <span class="unselectable">Last Year Values</span>
          </div>
          <div class="legend-item">
            <div class="legend-marker current-year"></div>
            <span class="unselectable">Current Year Estimates</span>
          </div>
        </div>
      </div>

      <div class="performance-goal">
        <div class="goal-label unselectable">Performance Value/Goal</div>
        <div class="goal-value unselectable">
          {{ getFormatedValue(temporaryPerformance || 0) }}%
        </div>
        <div class="goal-slider">
          <div class="slider-scale">
            <div class="min unselectable">0%</div>
            <div class="max unselectable">100%</div>
          </div>
          <div class="slider-track">
            <div
              class="marker last-year unselectable"
              [title]="getFormatedValue(measure.performanceLastYear || 0)"
              [style.left.%]="getFormatedValue(measure.performanceLastYear || 0)"
            >
              {{ getFormatedValue(measure.performanceLastYear || 0) }}
            </div>
            <div
              class="marker current-year"
              (mousedown)="startDragging($event)"
              [title]="getFormatedValue(temporaryPerformance || 0)"
              [style.left.%]="getFormatedValue(temporaryPerformance || 0)"
            >
              {{ getFormatedValue(temporaryPerformance || 0) }}
            </div>
          </div>
        </div>
      </div>

      <div class="points-goal" *ngIf="measure.isMIPS || measure.isMVP">
        <div class="goal-label unselectable">Estimated Points/Goal</div>
        <div class="goal-value unselectable">
          {{ getPoints(temporaryPerformance || 0) }}
        </div>
        <div class="goal-slider">
          <div class="slider-scale">
            <div class="min unselectable">0pts</div>
            <div class="max unselectable">10pts</div>
          </div>
          <div class="slider-track">
            <div
              class="marker last-year unselectable"
              [style.left.%]="getFormattedPoints(getPoints(measure.performanceLastYear || 0) * 10)"
            >
              {{ getFormattedPoints(getPoints(measure.performanceLastYear || 0)) }}
            </div>
            <div
              class="marker current-year"
              [style.left.%]="getFormattedPoints(getPoints(temporaryPerformance || 0) * 10)"
            >
              {{ getFormattedPoints(getPoints(temporaryPerformance || 0)) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noAdjustableGoal>
      <div class="goal-section">
        <div
          class="alert-box scoring-note"
          role="button"
          tabindex="0"
          (click)="goToScoringMeasure()"
          (keydown.enter)="goToScoringMeasure()"
          (keydown.space)="$event.preventDefault(); goToScoringMeasure()"
        >
          <mat-icon>info</mat-icon>
          <p>
            <strong>This population isn't scored on its own.</strong>
            Points for this measure are based on {{ scoringMeasureLabel }}.
            <span class="scoring-note-link">View {{ scoringMeasureLabel }} &rarr;</span>
          </p>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="calculation-details-container">
    <app-measure-calculation-details-prod
      [ipp]="measure.ipp ?? null"
      [denominator]="measure.denominator"
      [denomExclusion]="measure.denominatorExclusion ?? null"
      [denomException]="measure.denominatorException ?? null"
      [numerator]="measure.numerator"
      [performance]="measure.performance || 0"
      [performanceType]="measure.performanceType ?? null"
    >
    </app-measure-calculation-details-prod>
  </div>
</div>
